<template>
  <div class="page-detail orders-dinner-detail">
    <div class="title">订单详情</div>
    <div class="content" v-loading="loading">
      <div class="info-block order-info">
        <div class="title">
          订单编号：{{order.code}}
          <span class="state">{{getOrderStateName(order.status)}}</span>
        </div>
        <div class="sub-info">
          <div class="field">
            <div class="label">下单时间</div>
            <div class="text">{{Utils.dateFormat(order.createTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div class="label">接单时间</div>
            <div class="text">{{Utils.dateFormat(order.dispathTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div class="label">下单人</div>
            <div class="text">无</div>
          </div>
          <div class="field">
            <div class="label">开始服务时间</div>
            <div class="text">{{Utils.dateFormat(order.serviceTime, 'YYYY-MM-DD HH:mm:ss')}}</div>
          </div>
          <div class="field">
            <div class="label">完成时间</div>
            <div class="text">{{order.finishTime||'--'}}</div>
          </div>
          <div class="field">
            <div class="label">配送人员</div>
            <div class="text">{{order.servicePersonalName}}</div>
          </div>
          <div class="field">
            <div class="label">消费码</div>
            <div class="text">{{order.consumptionCode||'--'}}</div>
          </div>
          <!-- <div class="field">
            <div class="label">操作日志</div>
            <div class="text">无</div>
          </div>-->
        </div>
      </div>
      <div class="info-block service-target">
        <div class="title">服务对象信息</div>
        <div class="sub-info row">
          <div class="field">
            <div class="label">老人信息</div>
            <div class="text">
              <div class="field">
                <div class="label">姓名</div>
                <div class="text">{{info.name}}</div>
              </div>
              <div class="field">
                <div class="label">手机号</div>
                <div class="text">{{info.phone}}</div>
              </div>
              <div class="field">
                <div class="label">身份证</div>
                <div class="text">{{info.idCard}}</div>
              </div>
              <div class="field">
                <div class="label">年龄</div>
                <div class="text">{{info.age}}</div>
              </div>
              <div class="field">
                <div class="label">性别</div>
                <div class="text">{{info.gender|sexFilter}}</div>
              </div>
              <div class="field">
                <div class="label">老人类型</div>
                <div class="text">{{getNameOfOldManType(info.type)}}</div>
              </div>
              <div class="field">
                <div class="label">地址</div>
                <div class="text">{{info.residenceAddress}}</div>
              </div>
              <div class="field">
                <div class="label">标签</div>
                <div class="text">{{info.tagNames}}</div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="label">子女信息</div>
            <div class="text">
              <div class="field" v-for="item in contacts" :key="item.Gid">
                <div class="label">{{item.name}}</div>
                <div class="text">
                  <span>{{item.relationship}}</span>
                  <span>{{item.phone}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-block service-info">
        <div class="title">订餐信息</div>
        <div class="sub-info">
          <div class="field">
            <div class="label">餐厅</div>
            <div class="text">
              <p class="service-business-info">
                <span>{{order.serviceProviderName}}</span>
                <span>地址：{{order.address}}</span>
                <span>电话：{{order.cTelPhone}}</span>
              </p>
            </div>
          </div>
          <div class="field">
            <div class="label">菜品</div>
            <div class="text">
              <table
                class="menu-table"
                v-if="order.serviceItemSkuInfos && order.serviceItemSkuInfos.length"
              >
                <tbody>
                  <div v-for="(item, idx) in order.serviceItemSkuInfos || []" :key="item.gid">
                    <tr v-for="(skus, iSku) in item.Skus" :key="iSku">
                      <td>{{idx|getIndex(iSku,order.serviceItemSkuInfos)}}</td>
                      <td>{{item.ServiceItemName}}</td>
                      <td>{{skus && skus.ServiceItemSkuName}}</td>
                      <td>{{skus.Num}}</td>
                      <td>{{(skus && skus.Price || 0) * skus.Num}}元</td>
                      <td>
                        <i v-if="step === 1" @click="removeItem(idx)" class="el-icon-close"></i>
                      </td>
                    </tr>
                  </div>
                  <tr>
                    <td colspan="4">配送费</td>
                    <td>2元</td>
                  </tr>
                  <tr>
                    <td
                      colspan="5"
                    >总价：{{order.payment}}元（财政补贴：{{order.grantPayment}}元、个人账户付款：{{order.personPayment}}元）</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="sub-info">
          <div class="field">
            <div class="label">送餐时间</div>
            <div class="text">预约时间 {{remark.time}}</div>
          </div>
          <div class="field">
            <div class="label">送餐地址</div>
            <div class="text">{{info.residenceAddress}}</div>
          </div>
          <div class="field">
            <div class="label">联系电话</div>
            <div class="text">{{remark.tel}}</div>
          </div>
          <div class="field">
            <div class="label">备注</div>
            <div class="text">{{remark.remark}}</div>
          </div>
        </div>
      </div>
      <div class="info-block service-survey" v-if="order.status>4">
        <div class="title">回访记录</div>
        <div class="sub-info" v-for="(item,index) in followUpRecordList">
          <div class="field">
            <div class="label">时间</div>
            <div class="text">{{item.time}}</div>
          </div>
          <div class="field">
            <div class="label">操作人</div>
            <div class="text">{{item.operatorName}}</div>
          </div>
          <div class="field">
            <div class="label">内容</div>
            <div class="text">{{item.content}}</div>
          </div>
        </div>
        <div class="sub-info">
          <el-form labelWidth="150px" labelPosition="right">
            <el-form-item label="提交回访内容" style="width:600px;">
              <el-input type="textarea" :rows="6" placeholder="请输入回访内容" v-model="followContent"></el-input>
            </el-form-item>
            <el-form-item label>
              <el-button type="primary" size="medium" @click="uploadFollow()">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="actions">
      <el-button type="success" size="small" v-if="order.status === 3" @click="startService">开始服务</el-button>
      <el-button type="danger" size="small" v-if="order.status === 4" @click="endService">结束服务</el-button>
      <el-button type="warning" size="small" v-if="order.status < 4" @click="cancelOrder">取消订单</el-button>
    </div>
  </div>
</template>

<script>
import Promise from 'promise'
import qs from 'qs'

export default {
  filters: {
    getIndex(idx, skuIndex, selectedItems) {
      let index = 0;
      if (selectedItems) {
        for (let i = 0; i < selectedItems.length; i++) {
          if (i == idx) {
            index += (skuIndex + 1);
            return index;
          } else {
            index += selectedItems[i].Skus.length;
          }
        }
      }
      return index;
    }
  },
  data() {
    return {
      followUpRecordList: [],
      followContent: "",
      loading: false,
      order: {},
      info: {},
      contacts: [],
      service: {},
      remark: {}
    }
  },
  computed: {
    gid() {
      return this.$route.query.gid
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    uploadFollow() {
      this.Service.call('orderFollowUpRecord', 'POST', qs.stringify({
        orderGid: this.gid,
        content: this.followContent
      }), null, null, 'json', 'application/x-www-form-urlencoded').then(res => {
        if (res.data.code === 0) {
          this.$message.success('回访记录提交成功')
          this.$router.push("/orders/dinner")
        } else {
          this.$message.error(`回访记录提交失败:${res.des}`)
        }
      })
    },
    startService() {
      this.$confirm('确定开始服务？').then(() => {
        this.loading = true
        this.Service.call('housekeeping/start', 'POST', qs.stringify({
          ordergid: this.order.gid
        }), null, null, null, 'application/x-www-form-urlencoded').then(() => {
          this.$message.success('操作成功')
          this.loadData()
        }).catch(() => {
          this.loading = false
        })
      })
    },
    endService() {
      this.$confirm('确定结束服务？').then(() => {
        this.loading = true
        this.Service.call('housekeeping/end', 'POST', qs.stringify({
          ordergid: this.order.gid,
          pictures: '',
          remark: ''
        }), null, null, null, 'application/x-www-form-urlencoded').then(() => {
          this.$message.success('操作成功')
          this.loadData()
        }).catch(() => {
          this.loading = false
        })
      })
    },
    cancelOrder() {
      this.modal('OrderCancelModal', this.order).promise.then(rst => {
        if (rst === true) {
          this.loadData()
        }
      })
    },
    loadData() {
      if (!this.gid) {
        this.routeReplace('/orders/dinner')
        return
      }
      this.loading = true
      let order = {}
      this.Service.call("orderFollowUpRecord/list", "GET", { index: 0, size: 20, orderGid: this.gid }).then(res => {
        this.followUpRecordList = res.data;
      })
      this.Service.call('order/detail', 'GET', { gid: this.gid }).then(data => {
        order = data || {}
        let arr = (data.Remark || data.remark || '').split(',')
        this.remark = {
          time: arr[0] + ' ' + arr[1] || '',
          addr: arr[2] || '',
          tel: arr[3] || '',
          remark: arr[4] || ''
        }
        let task = []
        task.push(this.Service.call('theold/detail', 'GET', { gid: order.theOldGid }).then(data => {
          this.info = data || {}
        }).catch(() => { }))
        task.push(this.Service.call('usercontact', 'GET', { gid: order.theOldGid }).then(data => {
          this.contacts = data || []
        }).catch(() => { }))
        // let serviceId = order.servicePersonalGid
        // if (serviceId) {
        //   task.push(this.Service.call('serviceprovider/detail', 'GET', {gid: serviceId}).then(data => {
        //     this.service = data || {}
        //   }).catch(() => {}))
        // }
        Promise.all(task).finally(() => {
          try {
            order.serviceItemSkuInfos = JSON.parse(order.serviceItemSkuInfos)
            this.service = order.serviceItemSkuInfos[0]
            // let arr = (this.service.Remark || this.service.remark || '').split(',')
            // this.remark = {
            //   time: arr[0] + ' ' + arr[1] || '',
            //   addr: arr[2] || '',
            //   tel: arr[3] || '',
            //   remark: arr[4] || ''
            // }
            this.order = order
            Promise.all([
              this.Service.call('serviceprovider/detail', 'GET', { gid: this.order.serviceProviderGid }).then(data => {
                this.$set(this.order, 'address', data.address)
                this.$set(this.order, 'cTelPhone', data.cTelPhone)
              }).catch(() => { })
            ]).finally(() => {
              this.loading = false
            })
          } catch (e) {
            this.loading = false
          }
        })
      }).catch(() => {
        this.loading = false
      })
    }
  },
  watch: {
    '$route'() {
      this.loadData()
    }
  }
}
</script>
